import AddressFields from '@/components/AddressFields'
import PropertyDetailsForm from './PropertyDetailsForm'
import SectionForm, { useFormContext } from '../SectionForm'

const FieldList = [
  {name: "type_bien", label: "Type de bien", type: "select"},
  {name: "nombre_etages"}, 
  {name: "cadastre"},
  {name: "date_construction"},
  {name: "ref_batiment"}, 
  {name: "ref_escalier"}, 
  {name: "ref_etage"}, 
  {name: "details_cles", type: 'textarea'},
  {name: "numero_appartement"}, 
  {name: "numero_sonnette"}, 
  {name: "numero_parking"}, 
  {name: "adresse_ligne1"},
  {name: "adresse_ligne2"},
  {name: "adresse_ligne3" },
  {name: "code_postal" },
  {name: "ville"},
  {name: "disponibilite"},
  {name: "codage_interne"}
  // "immeuble_id"
]

const FormContent = () => {
  const { control, errors } = useFormContext()

  return (
    <>
      <PropertyDetailsForm />

      <div className="card bg-base-100 border border-base-200 rounded-none mb-4">
        <div className="card-body p-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex flex-col items-center gap-4">
              <AddressFields control={control} without={['pays']} errors={errors} />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const Form = ({ title = "", onClose = () => {}, onSuccess = () => {} }) => {
  return (
    <SectionForm
      title={title}
      columns={1}
      onClose={onClose}
      onSuccess={onSuccess}
      fields={FieldList.map( f => f.name)}
      addToSubmitFields={["immeuble", "immeuble_id"]}
    >
      <FormContent/>
    </SectionForm>
  )
}

export default Form